<template>
  <el-dialog :title="title"
             :visible.sync='showForm'
             :width="width"
             :close="close"
             :top="top"
             :close-on-click-modal='false'
             append-to-body>
    <el-form ref="form"
             :label-width="labelWidth"
             status-icon
             :model="formModel"
             :rules='rules'>
      <slot></slot>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close" v-if="showCloseBtn">{{ closeBtnText }}</el-button>
      <el-button type="primary" @click="ok" v-if="showOkBtn">{{ okBtnText }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: {
      visible: {
        required: true,
        type: Boolean
      },
      loading: {
        default: false
      },
      title: {},
      model: {},
      rules: {},
      width: {},
      top: {
        default: '15vh'
      },
      labelWidth: {
        default: '120px'
      },
      okText: {},
      closeText: {},
      showOkBtn: {
        default: true
      },
      showCloseBtn: {
        default: true
      }
    },
    data() {
      return {
        showForm: this.visible,
        formModel: this.model || {},
        okBtnText: this.okText ? this.okText : '保存',
        closeBtnText: this.closeText ? this.closeText : '关闭',
      }
    },
    watch: {
      showForm: function(value) {
        if(!value) {
          this.close();
        }
      },
    },
    methods: {
      close() {
        this.$refs['form'].resetFields();
        this.$emit('close');
      },
      ok() {
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.$emit('ok');
          }
        });
      },
      clearValidate(props) {
        this.$refs['form'].clearValidate(props);
      }
    },
    mounted() {
      this.Util.setSpinner(this, this.$el.firstChild)
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cx/cxDialog.vue